import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Album = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_ALBUM') && (
        <Forbidden module="album"/>
      )}
      { AuthService.hasRole('ROLE_ALBUM') && (
        <Outlet/>
      )}
    </>
  );
}
